<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-header">
      @if (displayItinerary) {
        <span i18n="@@moveItemDifferentItinerary"> Move Item to a Different Itinerary </span>
      }
      @if (!displayItinerary) {
        <span i18n="@@moveItemDifferentBasket"> Move Item to a Different Basket </span>
      }
    </h3>
    <button
      type="button"
      class="close"
      ngbAutoFocus
      (click)="close()"
      (keydown.enter)="close()"
      (keydown.space)="close()"
      aria-label="Close Move Item to a Different Basket Modal"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="flex-column-container">
      @for (basket of baskets; track basket; let index = $index) {
        @if (basket.id !== selectedBasketId) {
          <button appButton="small" (click)="moveItemToDifferentBasket(basket)" i18n="@@moveItemTo">
            Move item to {{ basket.title }}
          </button>
        }
      }
    </div>
  </div>
</div>
